<template>
  <!-- 只有总页数大于1的时候显示 -->
  <div class="paging">
    <!-- <a @click="handelClick(1)" class="pagingBtn" :class="{ disabled: current === 1 }">|&lt;&lt;</a> -->
    <a href="javascript:;" @click="handelClick(current - 1)" class="pagingBtn" :class="{ disabled: current === 1 }">上一页</a>
    <a href="javascript:;" style="margin: 0 4px;" @click="handelClick(n)"  class="pagingBtn" v-for="(n, i) in numbers" :key="i" :class="{ active: n === current }">{{ n }}</a>
    <a href="javascript:;" @click="handelClick(current + 1)" class="pagingBtn" :class="{ disabled: current === pageNumber }" >下一页</a>

    <span class="pagingTool">
      <span class="pagingText">跳至</span>
      <input type="number" v-model="pageNum" class="pagingInput" />
      <a href="javascript:;" @click="numClick(pageNum*1)" class="pagingBtn">确定</a>
    </span>
    <!-- <a @click="handelClick(pageNumber)" class="pagingBtn" :class="{ disabled: current === pageNumber }">&gt;&gt;|</a> -->
  </div>
</template>

<script>
export default {
  name: "MySitePager",
  props: {
    current: {
      type: Number,
      default: 5,
    },
    total: {
      type: Number,
      default: 220,
    },
    limit: {
      type: Number,
      default: 10,
    },
    visibileNumber: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      pageNum:''
    };
  },
  computed: {
    pageNumber() {
      return Math.ceil(this.total / this.limit);
    },
    // 页面展示的最小数字
    visibileMin() {
      let min = this.current - Math.floor(this.visibileNumber / 2);
      if (min < 1) {
        min = 1;
      }
      return min;
    },
    visibileMax() {
      let max = this.visibileMin + this.visibileNumber - 1;
      if (max > this.pageNumber) {
        max = this.pageNumber;
      }
      return max;
    },
    numbers() {
      let nums = [];
      for (let i = this.visibileMin; i <= this.visibileMax; i++) {
        nums.push(i);
      }
      return nums;
    },
  },
  mounted() {},

  methods: {
    handelClick(newPage) {
      this.pageNum = ''
      if (newPage < 1) {
        newPage = 1;
      }
      if (newPage > this.pageNumber) {
        newPage = this.pageNumber;
      }
      if (newPage === this.current) {
        return;
      }
      // 抛出一个事件
      this.$emit("pageChange", newPage);
    },
    numClick(newPage) {
      if (newPage < 1) {
        newPage = 1;
      }
      if (newPage > this.pageNumber) {
        newPage = this.pageNumber;
        this.pageNum = this.pageNumber
      }
      if (newPage === this.current) {
        return;
      }
      // 抛出一个事件
      this.$emit("pageChange", newPage);
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/pager.vue